/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import axios from 'axios';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';

export const dispatchErrorMessageData = (data) => ({
  type: actionTypes.HANDLE_ERROR_MSG_LB,
  payload: data,
});

export const dispatchGetLabelerDIffrences = (data) => ({
  type: actionTypes.GET_LABELER_DIFFERENCES,
  payload: data,
});

export const getLabelerDifferencesData = (val) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_LABEREL_DIFFERENCES, val)
    .then((response) => {
      return dispatch(dispatchGetLabelerDIffrences(response.data));
    })
    .catch((response) => {
      dispatch(dispatchGetLabelerDIffrences([]));
    });
};

export const dispatchGetLabelerDifferencesContract = (data) => ({
  type: actionTypes.GET_LABELER_DIFFERENCES_CONTRACT,
  payload: data,
});

export const getLabelerDifferencesContract = (val) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_CONTRACT_DIFFERENCES, val)
    .then((response) => {
      return dispatch(dispatchGetLabelerDifferencesContract(response.data));
    })
    .catch((response) => {
      dispatch(dispatchGetLabelerDifferencesContract([]));
    });
};

export const dispatchGetContactDifferencesMfginv = (data) => ({
  type: actionTypes.GET_CONTACT_DIFFERENCES_MFG,
  payload: data,
});

export const getContactDifferencesMfg = (val, action) => (dispatch) => {
  if (action === 'update') {
    dispatch(dispatchGetContactDifferencesMfginv(val));
  } else {
    return axios
      .post(serviceEndPoint.GET_CONTACT_DIFFERENCES_MFG_INV, val)
      .then((response) => {
        return dispatch(dispatchGetContactDifferencesMfginv(response.data));
      })
      .catch((response) => {
        dispatch(dispatchGetContactDifferencesMfginv([]));
      });
  }
};

export const dispatchGetContactDifferencesCmsinv = (data) => ({
  type: actionTypes.GET_CONTACT_DIFFERENCES_CMS,
  payload: data,
});

export const getContactDifferencesCms = (val, action) => (dispatch) => {
  if (action === 'update') {
    dispatch(dispatchGetContactDifferencesCmsinv(val));
  } else {
    return axios
      .post(serviceEndPoint.GET_CONTACT_DIFFERENCES_CMS_INV, val)
      .then((response) => {
        return dispatch(dispatchGetContactDifferencesCmsinv(response.data));
      })
      .catch((response) => {
        dispatch(dispatchGetContactDifferencesCmsinv([]));
      });
  }
};
export const dispatchGetSaveLabelerDifferencesCmsinv = (data) => ({
  type: actionTypes.SAVE_LABELER_DIFFERENCES,
  payload: data,
});

export const getSaveLabelerDifferences = (val) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_SAVE_LABELER_DIFFERENCES, val)
    .then((response) => {
      return dispatch(dispatchGetSaveLabelerDifferencesCmsinv(response.data));
    })
    .catch((response) => {
      dispatch(dispatchGetSaveLabelerDifferencesCmsinv([]));
    });
};
export const clearReduxforLabelarDifferences = () => {
  return {
    type: actionTypes.CLEAR_REDUX_LALELAR_DIFF,
  };
};
export const dispatchInputVal = (data) => ({
  type: actionTypes.INPUT_FIELD_VALUE,
  payload: data,
});

export const dispatchMfgId = (data) => ({
  type: actionTypes.MFG_ID,
  payload: data,
});
export const dispatchSingleLabeler = (data) => ({
  type: actionTypes.SINGLE_LABELER_DATA,
  payload: data,
});

export const setLabelerDiffTab = (data) => {
  if (data === null) {
    return { type: actionTypes.LABELER_DIFF_TAB_DATA, labelerDiffTabObj: {} };
  } else {
    return { type: actionTypes.LABELER_DIFF_TAB_DATA, labelerDiffTabObj: data };
  }
};
export const dispatchCheckedValue = (data) => ({
  type: actionTypes.GET_CHECKED_VALUE,
  payload: data,
});
export const dispatchTabValue = (data) => ({
  type: actionTypes.GET_TAB_VALUE,
  payload: data,
});
// clear redux
export const clearReduxForLabelerDifferenceScreen = () => (dispatch) => {
  dispatch(setLabelerDiffTab({}));
  dispatch(dispatchGetLabelerDIffrences([]));
  dispatch(dispatchInputVal(1));
  dispatch(dispatchErrorMessageData([]));
  dispatch(dispatchGetLabelerDifferencesContract([]));
  dispatch(dispatchGetContactDifferencesMfginv([]));
  dispatch(dispatchGetContactDifferencesCmsinv([]));
  dispatch(dispatchSingleLabeler({}));
  dispatch(dispatchMfgId(''));
  //dispatch(dispatchTabValue(''));
  dispatch(dispatchCheckedValue([]));
};
